import React from "react";
import UserForm from './UserForm';
import LaunchConfig from './LaunchConfig';
import Flights from './Flights';
import AddOns from './AddOns';
import Summary from './Summary';
import Next from './Next';
import Ignition from './Ignition';
import { Transition } from 'react-transition-group';
import { transitionStyles, duration, defaultStyle } from './constants';

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {
        userReady: false,
        /*name: 'michele',
        lastName: 'la corte',
        email: 'michele.lacorte@gmail.com',
        phone: '3922564738',
        company: 'frame',*/
        employees: '1-5'
      },
      formData: {
        formReady: false,
        /*purpose: 'iod',
        units: '1U',
        mass: '1-3kg',
        number_of_satellites: 1,
        altitude_max: 900,
        altitude_min: 100*/
      },
      flightData: {flightReady: false},
      addOnsData: {
        addOnsReady: false,
        addOns: []
      },
      summaryData: {
        agreement: false
      },
      ready: false
    };
  }

  handleSubmission = () => {
    alert('Form submitted!');
  }


  componentDidMount() {
    // if(step 2)
    // SLECT FROM DB
      // fill values

  }

  onSubmit(e) {
    e.preventDefault()
  }

  updateStateData = (data) => {
    const n = { [data.field]: data.value };
    this.setState({formData : {...this.state.data, ...n}});
  }

  setUserData = (data) => {
    console.log("USER "+data.field+": "+data.value);
    let userData = {...this.state.userData};
    userData[data.field] = data.value;
    this.setState({userData: userData});
  }

  setFormData = (data) => {
    let formData = {...this.state.formData};
    formData[data.field] = data.value;
    console.log(data.field, data.value)
    if(data.field == 'flight'){
      formData['formReady'] = true
      // scrollTo
    }
    this.setState({formData: formData});
  }

  setAddOnsData = (data) => {
    let formData = {...this.state.addOnsData};
    formData[data.field] = data.value;
    this.setState({addOnsData: formData});
  }

  setFlightData = (data) => {
    let formData = {...this.state.flightData};
    formData[data.field] = data.value;
    this.setState({flightData: formData});
  }

  setSummaryData = (data) => {
    let formData = {...this.state.summaryData};
    formData[data.field] = data.value;
    this.setState({summaryData: formData});
  }

  resetAtUser = () => {
    this.setUserData({field:'userReady', value: false});
    this.setFormData({field:'formReady', value: false});
    this.setFlightData({field:'flightReady', value: false});
    this.setAddOnsData({field:'addOnsReady', value: false});
  }

  resetAtForm = () => {
    this.setFormData({field:'formReady', value: false});
    this.setFlightData({field:'flightReady', value: false});
    this.setAddOnsData({field:'addOnsReady', value: false});
  }

  resetAtFlight = () => {
    this.setFlightData({field:'flightReady', value: false});
    this.setAddOnsData({field:'addOnsReady', value: false});
  }

  resetAtAddOns = () => {
    this.setAddOnsData({field:'addOnsReady', value: false});
  }

  end = () => {
    this.setState({ready: true})
  }

  render() {
    let step = 5;
    if(!this.state.userData.userReady)
      step = 5;
    if(
      (this.state.userData.userReady)&&
      (!this.state.formData.formReady)
    )
      step = 4;
    if(
      (this.state.userData.userReady)&&
      (this.state.formData.formReady)
    )
      step = 3;
    if(
      (this.state.userData.userReady)&&
      (this.state.formData.formReady)&&
      (this.state.flightData.flightReady)&&
      (!this.state.addOnsData.addOnsReady)
    )
      step = 2;
    if(
      (this.state.userData.userReady)&&
      (this.state.formData.formReady)&&
      (this.state.flightData.flightReady)&&
      (this.state.addOnsData.addOnsReady)&&
      (!this.state.ready)
    )
      step = 1
    if(this.state.ready)
      step = 0;
    return (
      <div>
        <div id="dorbitForm" className={"step-"+step}>
          <header>
          <nav className="navbar bg-light">
            <div className="container">
              <div className="d-flex flex-row align-items-center">
                <h1 className="logo"><span className="visually-hidden">D-ORBIT</span></h1>
                <h2 className="mb-0 h1">Launch Configurator <small className="visually-hidden">v3.0</small></h2>
              </div>
            </div>
          </nav>
          </header>
          <main className="container">

            <>
              <div id="userInfo" className="sec s5">
                <h2 className="h4 d-flex flex-row justify-content-between align-items-center">
                  <span>
                    <span className="num">5</span>
                    <span>User Information</span>
                  </span>
                  {((this.state.userData.userReady)&&(!this.state.ready))&&
                    <span className="editBtn" onClick={this.resetAtUser}>Edit</span>
                  }
                </h2>
                {(step==5)&&
                  <UserForm callback={this.setUserData} values={this.state.userData} />
                }
              </div>

              <div id="launchInfo" className="sec s4">
                <h2 className="h4 d-flex flex-row justify-content-between align-items-center">
                  <span>
                    <span className="num">4</span>
                    <span>Launch Details</span>
                  </span>
                  {((this.state.formData.formReady)&&(!this.state.ready))&&
                    <span className="editBtn" onClick={this.resetAtForm}>Edit</span>
                  }
                </h2>
                {(
                  step == 4
                )&&
                  <Transition in={true} timeout={300}>
                    {state => (
                     <div style={{
                       ...defaultStyle,
                       ...transitionStyles[state]
                     }}>
                       <div className="config">
                        <LaunchConfig callback={this.setFormData} values={this.state.formData} />
                       </div>
                     </div>
                  )}</Transition>
                }
              </div>


              {(
                (this.state.userData.userReady)&&
                (this.state.formData.purpose == 'ion')&&
                (this.state.ready == false)
              )&&
                <>
                  {((this.state.formData.notes)&&(this.state.formData.agreement == true))?
                   (<Next text="Confirm and Submit" btnClass="btn btn-success" callback={this.end} />)
                   :
                   (<Next text="Confirm and Submit" btnClass="btn btn-success btn-disabled" disabled />)
                  }
                </>
              }



                <>
                  <div id="flights" className="sec s3">
                    <h2 className="h4 d-flex flex-row justify-content-between align-items-center">
                      <span>
                        <span className="num">3</span>
                        <span>Select Your Preferred Flight</span>
                      </span>
                      {((this.state.flightData.flightReady)&&(!this.state.ready))&&
                        <span className="editBtn" onClick={this.resetAtFlight}>Edit</span>
                      }
                    </h2>
                    {(
                      step == 3
                    )&&
                      <Transition in={true} timeout={300}>
                        {state => (
                         <div style={{
                           ...defaultStyle,
                           ...transitionStyles[state]
                         }}>
                            <div className={((!this.state.addOnsData.addOnsReady) ? "d-block" : "d-none")}>
                              <Flights
                               formData={this.state.formData}
                               flightData={this.state.flightData}
                               callback={this.setFlightData}
                              />
                            </div>
                         </div>
                      )}</Transition>
                    }
                  </div>

                  <div id="addons" className="sec s2">
                    <h2 className="h4 d-flex flex-row justify-content-between align-items-center">
                      <span>
                        <span className="num">2</span>
                        <span>Additional Services</span>
                      </span>
                      {((this.state.addOnsData.addOnsReady)&&(!this.state.ready))&&
                        <span className="editBtn" onClick={this.resetAtAddOns}>Edit</span>
                      }
                    </h2>
                    {(
                      step == 2
                    )&&
                      (<Transition in={true} timeout={300}>
                        {state => (
                         <div style={{
                           ...defaultStyle,
                           ...transitionStyles[state]
                         }}>
                            <AddOns
                             callback={this.setAddOnsData}
                             values={this.state.addOnsData}
                            />
                         </div>
                      )}</Transition>)
                    }
                  </div>

                  <div id="summary" className="sec s1">
                    <h2 className="h4">
                      <span>
                        <span className="num">1</span>
                        <span>Summary &amp; Confirmation</span>
                      </span>
                    </h2>
                    {(
                      step == 1
                    )&&
                        <>
                          <Summary
                            userData={this.state.userData}
                            formData={this.state.formData}
                            flightData={this.state.flightData}
                            addOnsData={this.state.addOnsData}
                            summaryData={this.state.summaryData}
                            callback={this.setSummaryData}
                            end={this.end}
                          />
                        </>
                    }
                  </div>
                </>


              <div id="ignition" className="sec s0">
                <h2 className="h4">
                  <span>
                    <span className="num">0</span>
                    <span>Ignition</span>
                  </span>
                </h2>
                {(
                  (this.state.ready)
                )&&
                  <Ignition
                    userData={this.state.userData}
                    formData={this.state.formData}
                    flightData={this.state.flightData}
                    addOnsData={this.state.addOnsData}
                  />
                }
              </div>
            </>


          </main>

        </div>
      </div>
    );
  }
}
